import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { GoogleDrivePicker } from './GoogleDrivePicker';
import { DropboxChooser } from './DropboxChooser';
import { Cloud } from 'lucide-react';

export const CloudImportDialog = ({ open, onOpenChange, onImport }) => {
  const [activeTab, setActiveTab] = useState('google');

  const handleGoogleFilesSelected = async (files) => {
    // Transform Google Drive files for import (no accessToken needed - uses stored credentials)
    const importFiles = files.map(file => ({
      source: 'google_drive',
      fileId: file.id || file.fileId,
      name: file.name,
      mimeType: file.mimeType,
    }));
    
    await onImport(importFiles, 'google_drive');
  };

  const handleDropboxFilesSelected = async (files) => {
    // Transform Dropbox files for import
    const importFiles = files.map(file => ({
      source: 'dropbox',
      name: file.name,
      url: file.link,
      bytes: file.bytes,
    }));
    
    await onImport(importFiles, 'dropbox');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Cloud className="w-5 h-5 text-[#1E3A5F]" />
            Import from Cloud Storage
          </DialogTitle>
          <DialogDescription>
            Select images from your cloud storage to add to your Media Library
          </DialogDescription>
        </DialogHeader>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mt-4">
          <TabsList className="grid w-full grid-cols-2 mb-4">
            <TabsTrigger 
              value="google"
              className="data-[state=active]:bg-[#4285F4]/10 data-[state=active]:text-[#4285F4]"
            >
              <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none">
                <path d="M4.5 14.5L8 9L15.5 9L12 14.5H4.5Z" fill="#4285F4"/>
                <path d="M8 9L12 2L19.5 2L15.5 9H8Z" fill="#0F9D58"/>
                <path d="M15.5 9L19.5 2L23 8.5L19 15.5L15.5 9Z" fill="#FFCD40"/>
              </svg>
              Google Drive
            </TabsTrigger>
            <TabsTrigger 
              value="dropbox"
              className="data-[state=active]:bg-[#0061FF]/10 data-[state=active]:text-[#0061FF]"
            >
              <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="#0061FF">
                <path d="M6 2L12 6L6 10L0 6L6 2Z"/>
                <path d="M18 2L24 6L18 10L12 6L18 2Z"/>
              </svg>
              Dropbox
            </TabsTrigger>
          </TabsList>

          <TabsContent value="google" className="mt-0">
            <GoogleDrivePicker 
              onFilesSelected={handleGoogleFilesSelected}
              onClose={() => onOpenChange(false)}
            />
          </TabsContent>

          <TabsContent value="dropbox" className="mt-0">
            <DropboxChooser 
              onFilesSelected={handleDropboxFilesSelected}
              onClose={() => onOpenChange(false)}
            />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default CloudImportDialog;
